import { normalizeSubscriber } from "./normalizeSubscriber.js";
class SequentialPairsObserver {
    #previousValue;
    #subscriber;
    constructor(initialValue, subscriber) {
        this.#previousValue = initialValue;
        this.#subscriber = subscriber;
    }
    next(currentValue) {
        const pair = [this.#previousValue, currentValue];
        normalizeSubscriber(this.#subscriber).next(pair);
        this.#previousValue = currentValue;
    }
}
/**
 * Creates an observer that emits sequential pairs of values.
 *
 * @example
 *
 * ```ts
 * import { createReference, sequentialPairs } from "@knyt/artisan";
 *
 * const observer = sequentialPairs(0, ([previousValue, currentValue]) => {
 *   // Handle the sequential pair
 * })
 *
 * createReference(0).subscribe(observer);
 *
 * @alpha This API is experimental and may change in future releases without notice.
 */
export function sequentialPairs(initialValue, subscriber) {
    return new SequentialPairsObserver(initialValue, subscriber);
}
